import { useQuery } from "react-query";
import { GET_DISCHARGE_PLANNING, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getDischargePlanning } from "api/clinicalManagement";
import extractRecords from "../utils/extractRecords";

export type DischargePlanningRecord = Record<string, unknown>;

const useGetDischargePlanning = (clientId: number | null) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_DISCHARGE_PLANNING, clientId],
    () => getDischargePlanning(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  const records = extractRecords<DischargePlanningRecord>(data);

  const dischargePlanning = records.length > 0 ? records[0] : null;

  return {
    dischargePlanning,
    dischargePlanningLoading: isLoading,
    refetchDischargePlanning: refetch,
    ...rest,
  };
};

export default useGetDischargePlanning;
